import React, { useEffect } from 'react'
import Trusted from '../HomeMain/Trusted/Main'
import AboutApp from '../HomeMain/AboutApp/Main'
import Design from '../HomeMain/Design/Main'
import Testimonial from '../HomeMain/Testimonial/Main'
import Pricing from '../HomeMain/Pricing/Main'
import Faq from '../HomeMain/Faq/Main'
import Interface from '../HomeMain/Interface/Main'
import Download from '../HomeMain/Download/Main'
import Story from '../HomeMain/Story/Main'
import Banner from '../Menhomevideotwo/Banner';
import Features from '../Menhomevideotwo/Features';
import Steps from '../Menhomevideotwo/Steps';

const Main = ({ setfooter, setnavbar, setbrdcum }) => {

  useEffect(() => {
    setfooter({ f4: true })
    setnavbar({ n4: true })
    setbrdcum({ b4: true })
    localStorage.setItem("navbar", "homevideotwo")

  }, [])

  return (
    <>
      <Banner />
      <Features />
      <AboutApp video={true} />
      <Design />
      <Steps />
      <Testimonial />
      <Trusted />
      <Pricing video={true} />
      <Faq />
      <Interface />
      <Download />
      <Story />
    </>
  )
}

export default Main